import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as jQuery from 'jquery';

import Config from './Config';
import ReadMessage from './tasks/ReadMessage/ReadMessage';
import ComposeMessage from './tasks/ComposeMessage/ComposeMessage';
import RedirectToPortalPage from './tasks/RedirectToPortalPage/RedirectToPortalPage';
import Error from './tasks/Error/Error';
import * as FunctionFile from './FunctionFile';

export { FunctionFile };


export function init(container: any) {

    var pane = getParameterByName('pane');
    var embedUrl = getParameterByName('embedUrl');

    var componentToRender: JSX.Element;

    if (pane == 'read') {
        componentToRender = <ReadMessage />;
    }
    else if (pane == 'compose') {
        componentToRender = <ComposeMessage />;
    }
    else if (pane == 'functionFile') {
        // no ui displayed - this is for add-in command ExecuteFunction buttons
        componentToRender = <span />;
    }
    else if (embedUrl && embedUrl.length > 0) {
        componentToRender = <RedirectToPortalPage embedUrl={embedUrl} />;
    }
    else {
        componentToRender = <Error message="Invalid parameters." />;
    }

    Office.initialize = function (reason) {
        jQuery(document).ready(function () {
            ReactDOM.render(componentToRender, container);
        });
    };
};


// Based on code from https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
function getParameterByName(name: string, url?: string): string {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/entry.tsx